export const Types = Object.freeze({
    User: 0,
    Guest: 1,
    Training: 2,
    Game: 3
})